import { useState, useEffect } from "react";
import cx from "classnames";
import { models } from "../../data";
import "./ColorPanel.css";
import { AspectRatio } from "react-aspect-ratio";
import { animated, useTransition } from "@react-spring/web";

const ColorPanelSection = ({
  active,
  setActive,
}: {
  active: number;
  setActive: (active: number) => void;
}) => {
  const [color, setColor] = useState<string>(models[active].variants[0].name);
  const transitions = useTransition(`${active}-${color}`, {
    initial: { opacity: 1 },
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 1 },
  });

  const renderColorSwatch = () => {
    return (
      <div className="swatch flex flex-row items-center">
        {models[active].variants.map((c) => (
          <div
            key={c.name}
            className={cx("color", color === c.name && "active", c.front)}
            style={{ backgroundColor: c.color }}
            role="button"
            onClick={() => setColor(c.name)}
          />
        ))}
      </div>
    );
  };

  const renderModels = () => {
    return (
      <div className="flex">
        <div className="models">
          {models.map(({ short }, index) => (
            <div
              key={short}
              className={cx("model", index === active && "active")}
              role="button"
              onClick={() => setActive(index)}
            >
              {short}
            </div>
          ))}
        </div>
      </div>
    );
  };

  useEffect(() => {
    setTimeout(() => {
      if (!models[active].variations[color])
        setColor(models[active].variants[0].name);
    }, 300);
  }, [active]);

  return (
    <section className="section-color-panel">
      <div className="container mx-auto">
        <div className="title font-medium">
          <div>อิสระในการเลือก</div>
          <div>ด้วยโทนหลากสีสัน</div>
        </div>
        <div className="grid">
          <div className="controller">
            <div>สี</div>
            {renderColorSwatch()}
            <div>รุ่น</div>
            {renderModels()}
          </div>
          {transitions(({ opacity }, item) => {
            const [activeStr, color] = item.split("-");
            const active = parseInt(activeStr, 10);

            let renderColor = color;
            if (!models[active].variations[color])
              renderColor = models[active].variants[0].name;
            return (
              <>
                <animated.div className="front" style={{ opacity }}>
                  <img
                    src={models[active].variations[renderColor]?.full}
                    alt={`Full ${item}`}
                  />
                </animated.div>
                <animated.div className="side" style={{ opacity }}>
                  <AspectRatio
                    ratio="540/350"
                    style={{
                      width: "100%",
                      height: "100%",
                    }}
                  >
                    <img
                      src={models[active].variations[renderColor]?.side}
                      alt={`Side ${renderColor}`}
                    />
                  </AspectRatio>
                </animated.div>
                <animated.div className="face" style={{ opacity }}>
                  <AspectRatio
                    ratio="540/350"
                    style={{ width: "100%", height: "100%" }}
                  >
                    <img
                      src={models[active].variations[renderColor]?.front}
                      alt={`Front ${renderColor}`}
                    />
                  </AspectRatio>
                </animated.div>
              </>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ColorPanelSection;
